import { api } from './authService'; // Importamos la instancia configurada de Axios

/**
 * @description Obtiene la lista de todos los reportes de mantenimiento.
 * Solo accesible por roles ADMIN y SUPERVISOR.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con el listado de reportes.
 */
const getAllMaintenanceReports = () => {
  return api.get('/maintenance-reports');
};

/**
 * @description Obtiene todos los reportes de mantenimiento asociados a un equipo específico.
 * @param {number | string} equipmentId El ID del equipo del que se quieren obtener los reportes.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con los reportes del equipo.
 */
const getMaintenanceReportsByEquipment = (equipmentId) => {
  return api.get(`/maintenance-reports/by-equipment/${equipmentId}`);
};

/**
 * @description Obtiene el detalle completo de un reporte de mantenimiento por su ID.
 * La respuesta incluye el campo `checklist_detail` con el desglose de cada ítem.
 * @param {number | string} id El ID del reporte a obtener.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con el reporte detallado.
 */
const getMaintenanceReportById = (id) => {
  return api.get(`/maintenance-reports/${id}`);
};

const maintenanceService = {
  getAllMaintenanceReports,
  getMaintenanceReportsByEquipment,
  getMaintenanceReportById,
};

export default maintenanceService;
